export const getHeader = (isNewEntry: boolean) =>
  isNewEntry
    ? [{ name: "name", label: "Name", style: { width: "auto" } }]
    : [
        {
          name: "name",
          label: "Name",
          style: { width: "45%" },
        },
        {
          name: "date",
          label: "Date",
          style: { width: "30%" },
        },
        {
          name: "type",
          label: "Type",
          style: { width: "10%" },
        },
        {
          name: "actions",
          label: "Actions",
          style: { width: "15%" },
        },
      ];
